/* RRAT's Outdoor 2026 · JavaScript del tema (What! Marketing). Sin dependencias. */
(() => {
  'use strict';

  const T = window.theme || {};
  const $ = (sel, root = document) => root.querySelector(sel);
  const $$ = (sel, root = document) => Array.from(root.querySelectorAll(sel));
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const debounce = (fn, wait = 300) => {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn(...args), wait);
    };
  };
  const parseHTML = (html) => new DOMParser().parseFromString(html, 'text/html');

  /* ---------- Formato de precio (Shopify money_format) ---------- */
  const formatMoney = (cents, format = T.moneyFormat || '{{amount_with_comma_separator}} €') => {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    const value = Number(cents) / 100;
    const fmt = (n, decimals, thousands, decimal) => {
      const parts = n.toFixed(decimals).split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
      return parts.join(decimal);
    };
    return format.replace(/\{\{\s*(\w+)\s*\}\}/, (_, key) => {
      switch (key) {
        case 'amount': return fmt(value, 2, ',', '.');
        case 'amount_no_decimals': return fmt(value, 0, ',', '.');
        case 'amount_with_comma_separator': return fmt(value, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return fmt(value, 0, '.', ',');
        case 'amount_with_apostrophe_separator': return fmt(value, 2, "'", '.');
        case 'amount_with_space_separator': return fmt(value, 2, ' ', ',');
        default: return fmt(value, 2, '.', ',');
      }
    });
  };

  /* ---------- Aviso breve ---------- */
  const toast = (msg) => {
    let el = $('.toast');
    if (!el) {
      el = document.createElement('div');
      el.className = 'toast';
      el.setAttribute('role', 'status');
      document.body.appendChild(el);
    }
    el.textContent = msg;
    el.classList.add('is-visible');
    clearTimeout(el._t);
    el._t = setTimeout(() => el.classList.remove('is-visible'), 3500);
  };

  /* ---------- Cajones y modales ---------- */
  let lastFocus = null;
  const openDrawer = (el) => {
    if (!el) return;
    lastFocus = document.activeElement;
    // Los modales dentro de una sección quedan atrapados bajo la cabecera fija: se llevan al body.
    if (el.classList.contains('modal') && el.parentElement !== document.body) {
      $$(`body > [id="${el.id}"]`).forEach((old) => old.remove());
      document.body.appendChild(el);
    }
    el.hidden = false;
    requestAnimationFrame(() => el.classList.add('is-open'));
    el.setAttribute('aria-hidden', 'false');
    document.body.classList.add('is-locked');
    $$(`[aria-controls="${el.id}"]`).forEach((b) => b.setAttribute('aria-expanded', 'true'));
    const focusable = $('[autofocus], input:not([type=hidden]), button, a[href]', $('.drawer__panel, .modal__panel', el) || el);
    setTimeout(() => focusable && focusable.focus({ preventScroll: true }), 60);
  };
  const closeDrawer = (el) => {
    if (!el || !el.classList.contains('is-open')) return;
    el.classList.remove('is-open');
    el.setAttribute('aria-hidden', 'true');
    $$(`[aria-controls="${el.id}"]`).forEach((b) => b.setAttribute('aria-expanded', 'false'));
    if (!$('.drawer.is-open, .modal.is-open')) document.body.classList.remove('is-locked');
    if (lastFocus && document.contains(lastFocus)) lastFocus.focus({ preventScroll: true });
  };

  document.addEventListener('click', (e) => {
    const opener = e.target.closest('[data-open]');
    if (opener) {
      const target = document.getElementById(opener.dataset.open);
      if (target) {
        e.preventDefault();
        openDrawer(target);
        if (opener.dataset.open === 'SearchDrawer') setTimeout(() => { const i = $('#SearchDrawer input[type=search]'); i && i.focus(); }, 80);
      }
      return;
    }
    const closer = e.target.closest('[data-close]');
    if (closer) {
      e.preventDefault();
      closeDrawer(closer.closest('.drawer, .modal'));
    }
  });
  document.addEventListener('keydown', (e) => {
    if (e.key !== 'Escape') return;
    $$('.drawer.is-open, .modal.is-open').forEach(closeDrawer);
    $$('.nav__item.is-open').forEach((i) => toggleNav(i, false));
  });

  /* ---------- Barra de anuncios (móvil: rotación) ---------- */
  const initAnnouncement = () => {
    const items = $$('.announcement__item');
    if (items.length < 2) return;
    let i = 0;
    items[0].classList.add('is-active');
    if (reduceMotion) return;
    setInterval(() => {
      items[i].classList.remove('is-active');
      i = (i + 1) % items.length;
      items[i].classList.add('is-active');
    }, 4500);
  };

  /* ---------- Header: altura, ocultar al bajar, menú desplegable ---------- */
  const header = $('.site-header');
  const setHeaderH = () => {
    if (header) document.documentElement.style.setProperty('--header-h', `${header.offsetHeight}px`);
  };
  const initHeader = () => {
    if (!header) return;
    setHeaderH();
    window.addEventListener('resize', debounce(setHeaderH, 150));
    if (header.dataset.hideOnScroll === 'true') {
      let lastY = window.scrollY;
      window.addEventListener('scroll', () => {
        const y = window.scrollY;
        const open = $('.nav__item.is-open');
        const hide = y > lastY && y > 300 && !open;
        header.classList.toggle('is-hidden', hide);
        document.documentElement.classList.toggle('header-hidden', hide);
        lastY = y;
      }, { passive: true });
    }
  };

  function toggleNav(item, open) {
    if (!item) return;
    item.classList.toggle('is-open', open);
    const btn = $('.nav__link', item);
    if (btn) btn.setAttribute('aria-expanded', String(open));
  }
  const initNav = () => {
    $$('.nav__item[data-has-dropdown]').forEach((item) => {
      let t;
      item.addEventListener('mouseenter', () => {
        clearTimeout(t);
        $$('.nav__item.is-open').forEach((o) => o !== item && toggleNav(o, false));
        toggleNav(item, true);
      });
      item.addEventListener('mouseleave', () => { t = setTimeout(() => toggleNav(item, false), 120); });
      const btn = $('.nav__link', item);
      btn.addEventListener('click', (e) => {
        if (btn.tagName === 'A' && window.matchMedia('(hover: hover)').matches) return;
        e.preventDefault();
        const open = !item.classList.contains('is-open');
        $$('.nav__item.is-open').forEach((o) => toggleNav(o, false));
        toggleNav(item, open);
      });
      item.addEventListener('focusout', (e) => {
        if (!item.contains(e.relatedTarget)) toggleNav(item, false);
      });
    });
  };

  /* ---------- Búsqueda predictiva ---------- */
  const initSearch = () => {
    const root = $('#SearchDrawer');
    if (!root) return;
    const input = $('input[type=search]', root);
    const results = $('[data-predictive]', root);
    if (!input || !results || !T.routes) return;
    let controller;
    const run = debounce(async () => {
      const q = input.value.trim();
      if (q.length < 2) { results.innerHTML = ''; return; }
      if (controller) controller.abort();
      controller = new AbortController();
      try {
        const url = `${T.routes.predictive_search_url}?q=${encodeURIComponent(q)}&section_id=predictive-search&resources[type]=product,collection,page,article&resources[limit]=8&resources[options][unavailable_products]=last`;
        const res = await fetch(url, { signal: controller.signal });
        const html = await res.text();
        const inner = $('#shopify-section-predictive-search', parseHTML(html)) || parseHTML(html).body;
        results.innerHTML = inner.innerHTML;
      } catch (e) {
        if (e.name !== 'AbortError') results.innerHTML = '';
      }
    }, 250);
    input.addEventListener('input', run);
  };

  /* ---------- Carrito ---------- */
  const cartSections = () => {
    const ids = ['cart-drawer', 'cart-count'];
    if ($('[data-cart-page]')) ids.push($('[data-cart-page]').dataset.sectionId);
    return ids;
  };
  const renderCartSections = (sections) => {
    if (!sections) return;
    if (sections['cart-drawer']) {
      const doc = parseHTML(sections['cart-drawer']);
      const fresh = $('[data-cart-drawer-inner]', doc);
      const current = $('[data-cart-drawer-inner]');
      if (fresh && current) current.replaceWith(fresh);
    }
    if (sections['cart-count']) {
      const doc = parseHTML(sections['cart-count']);
      const count = $('[data-cart-count-value]', doc);
      $$('[data-cart-count]').forEach((el) => { el.textContent = count ? count.textContent.trim() : ''; });
    }
    const page = $('[data-cart-page]');
    if (page && sections[page.dataset.sectionId]) {
      const doc = parseHTML(sections[page.dataset.sectionId]);
      const fresh = $('[data-cart-page]', doc);
      if (fresh) page.replaceWith(fresh);
    }
    document.dispatchEvent(new CustomEvent('cart:updated'));
  };
  const openCart = () => {
    if (T.cartType === 'page') { window.location.href = T.routes.cart_url; return; }
    openDrawer($('#CartDrawer'));
  };
  const postJSON = async (url, body) => {
    const res = await fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    });
    const data = await res.json();
    if (!res.ok || data.status) throw new Error(data.description || data.message || T.strings.cartError);
    return data;
  };
  const addToCart = async (items, button) => {
    if (button) button.classList.add('is-loading');
    try {
      const data = await postJSON(`${T.routes.cart_add_url}.js`, { items, sections: cartSections(), sections_url: window.location.pathname });
      renderCartSections(data.sections);
      openCart();
      return true;
    } catch (err) {
      toast(err.message);
      return false;
    } finally {
      if (button) button.classList.remove('is-loading');
    }
  };
  const changeLine = async (line, quantity) => {
    const wrap = $('[data-cart-drawer-inner]') || $('[data-cart-page]');
    if (wrap) wrap.style.opacity = '.6';
    try {
      const data = await postJSON(`${T.routes.cart_change_url}.js`, { line, quantity, sections: cartSections(), sections_url: window.location.pathname });
      renderCartSections(data.sections);
    } catch (err) {
      toast(err.message);
      const w = $('[data-cart-drawer-inner]') || $('[data-cart-page]');
      if (w) w.style.opacity = '';
    }
  };

  document.addEventListener('submit', async (e) => {
    const form = e.target.closest('form[data-type="add-to-cart-form"]');
    if (!form || T.cartType === 'page') return;
    e.preventDefault();
    const fd = new FormData(form);
    const id = fd.get('id');
    if (!id) return;
    const item = { id: Number(id), quantity: Number(fd.get('quantity') || 1) };
    const props = {};
    for (const [k, v] of fd.entries()) {
      const m = k.match(/^properties\[(.+)\]$/);
      if (m && v) props[m[1]] = v;
    }
    if (Object.keys(props).length) item.properties = props;
    const sellingPlan = fd.get('selling_plan');
    if (sellingPlan) item.selling_plan = sellingPlan;
    const btn = $('[type=submit]', form);
    const err = $('.buy__error', form.closest('[data-product]') || form);
    if (err) err.textContent = '';
    const ok = await addToCart([item], btn);
    if (!ok && err) err.textContent = T.strings.cartError;
  });

  document.addEventListener('click', (e) => {
    const quick = e.target.closest('[data-quick-add]');
    if (quick) {
      e.preventDefault();
      const select = quick.closest('[data-quick-add-scope]') && $('select', quick.closest('[data-quick-add-scope]'));
      const id = select ? select.value : quick.dataset.variantId;
      if (id) addToCart([{ id: Number(id), quantity: 1 }], quick);
      return;
    }
    const remove = e.target.closest('[data-cart-remove]');
    if (remove) {
      e.preventDefault();
      changeLine(Number(remove.dataset.cartRemove), 0);
      return;
    }
    const step = e.target.closest('[data-qty-step]');
    if (step) {
      const input = $('input', step.closest('.qty'));
      if (!input) return;
      const next = Math.max(Number(input.min || 0), Number(input.value || 0) + Number(step.dataset.qtyStep));
      input.value = next;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }
  });
  document.addEventListener('change', (e) => {
    const input = e.target.closest('[data-cart-line]');
    if (input) {
      changeLine(Number(input.dataset.cartLine), Number(input.value));
      return;
    }
    const note = e.target.closest('[data-cart-note]');
    if (note) {
      postJSON(`${T.routes.cart_update_url}.js`, { note: note.value }).catch(() => {});
    }
  });

  /* ---------- Ficha de producto ---------- */
  class ProductInfo {
    constructor(root) {
      this.root = root;
      const json = $('[data-product-json]', root);
      if (!json) return;
      this.product = JSON.parse(json.textContent);
      this.form = $('form[data-type="add-to-cart-form"]', root);
      this.idInput = this.form && $('input[name=id]', this.form);
      this.button = this.form && $('[type=submit]', this.form);
      this.priceEl = $('[data-price]', root);
      this.sticky = $('[data-sticky-atc]');
      this.root.addEventListener('change', (e) => {
        if (e.target.closest('[data-option-index]')) this.onChange();
      });
      this.update(false);
      this.initGallery();
      this.initSticky();
    }

    selected() {
      return this.product.options.map((_, i) => {
        const checked = $(`[data-option-index="${i}"]:checked`, this.root);
        const select = $(`select[data-option-index="${i}"]`, this.root);
        return checked ? checked.value : select ? select.value : null;
      });
    }

    findVariant(values) {
      return this.product.variants.find((v) => v.options.every((o, i) => values[i] == null || o === values[i]));
    }

    onChange() {
      let values = this.selected();
      let variant = this.findVariant(values);
      if (!variant) {
        // Combinación inexistente: mantener la primera opción y elegir la primera variante disponible.
        variant = this.product.variants.find((v) => v.options[0] === values[0] && v.available) || this.product.variants.find((v) => v.options[0] === values[0]);
        if (variant) {
          variant.options.forEach((val, i) => {
            const input = $(`[data-option-index="${i}"][value="${CSS.escape(val)}"]`, this.root);
            if (input && input.type === 'radio') input.checked = true;
          });
        }
      }
      this.variant = variant;
      this.update(true);
    }

    update(fromUser) {
      const values = this.selected();
      const variant = this.variant || this.findVariant(values);
      this.variant = variant;
      this.markAvailability(values);
      // Etiquetas del valor elegido
      values.forEach((val, i) => {
        const label = $(`[data-option-value-label="${i}"]`, this.root);
        if (label) label.textContent = val || '';
      });
      if (!variant) {
        this.setButton(false, T.strings.unavailable);
        return;
      }
      if (this.idInput) this.idInput.value = variant.id;
      $$('[data-variant-id-input]').forEach((i) => { i.value = variant.id; });
      if (this.priceEl) {
        const sale = variant.compare_at_price && variant.compare_at_price > variant.price;
        this.priceEl.classList.toggle('price--sale', !!sale);
        this.priceEl.innerHTML = `<span class="price__now">${formatMoney(variant.price)}</span>${sale ? `<s class="price__was"><span class="visually-hidden">${T.strings.regularPrice}</span>${formatMoney(variant.compare_at_price)}</s>` : ''}`;
        $$('[data-sticky-price]').forEach((el) => { el.textContent = formatMoney(variant.price); });
      }
      this.setButton(variant.available, variant.available ? `${T.strings.addToCart} · ${formatMoney(variant.price)}` : T.strings.soldOut);
      $$('[data-sticky-variant]').forEach((el) => { el.textContent = variant.title === 'Default Title' ? '' : variant.title; });
      if (fromUser) {
        if (!this.root.hasAttribute('data-no-url')) {
          const url = new URL(window.location.href);
          url.searchParams.set('variant', variant.id);
          window.history.replaceState({}, '', url.toString());
        }
        if (variant.featured_media) this.showMedia(variant.featured_media.id);
        document.dispatchEvent(new CustomEvent('variant:change', { detail: { variant } }));
      }
    }

    setButton(available, text) {
      [this.button, $('[data-sticky-atc] button')].forEach((b) => {
        if (!b || b.hasAttribute('data-sticky-goto')) return;
        b.disabled = !available;
        const label = $('[data-button-label]', b) || b;
        label.textContent = b === this.button ? text : (available ? T.strings.addToCart : T.strings.soldOut);
      });
    }

    markAvailability(values) {
      this.product.options.forEach((_, i) => {
        $$(`[data-option-index="${i}"]`, this.root).forEach((input) => {
          if (input.tagName === 'SELECT') return;
          const test = values.slice();
          test[i] = input.value;
          const match = this.product.variants.filter((v) => v.options.every((o, j) => (j === i ? o === input.value : j < i ? o === test[j] : true)));
          const exact = this.product.variants.find((v) => v.options.every((o, j) => o === test[j]));
          const available = i === 0 ? match.some((v) => v.available) : !!(exact && exact.available);
          const wrap = input.closest('.opt-size, .opt-swatch');
          if (wrap) wrap.classList.toggle('is-unavailable', !available);
          if (wrap) {
            const sr = $('[data-sr-status]', wrap);
            if (sr) sr.textContent = available ? '' : ` (${T.strings.soldOut})`;
          }
        });
      });
    }

    initGallery() {
      this.track = $('.gallery__track', this.root);
      if (!this.track) return;
      const dots = $$('.gallery__dots span', this.root);
      if (dots.length) {
        this.track.addEventListener('scroll', debounce(() => {
          const i = Math.round(this.track.scrollLeft / this.track.clientWidth);
          dots.forEach((d, n) => d.classList.toggle('is-active', n === i));
        }, 60), { passive: true });
      }
    }

    showMedia(id) {
      if (!this.track) return;
      const item = $(`[data-media-id="${id}"]`, this.track);
      if (!item) return;
      $$('[data-lp-thumb]', this.root).forEach((t) => t.classList.toggle('is-active', t.dataset.lpThumb === String(id)));
      if (window.matchMedia('(max-width: 989px)').matches) {
        this.track.scrollTo({ left: item.offsetLeft, behavior: reduceMotion ? 'auto' : 'smooth' });
      } else {
        $$('.gallery__item', this.track).forEach((el) => el.classList.toggle('is-featured', el === item));
      }
    }

    initSticky() {
      $$('[data-lp-thumb]', this.root).forEach((t) => t.addEventListener('click', () => this.showMedia(t.dataset.lpThumb)));
      if (this.root.hasAttribute('data-sticky-landing')) { this.initLandingSticky(); return; }
      if (!this.sticky || !this.button || !('IntersectionObserver' in window)) return;
      const io = new IntersectionObserver(([entry]) => {
        const passed = !entry.isIntersecting && entry.boundingClientRect.top < 0;
        this.sticky.classList.toggle('is-visible', passed);
        this.sticky.setAttribute('aria-hidden', String(!passed));
      });
      io.observe(this.button);
      const stickyBtn = $('button', this.sticky);
      if (stickyBtn) {
        stickyBtn.addEventListener('click', () => {
          if (this.form.requestSubmit) this.form.requestSubmit(this.button);
          else this.button.click();
        });
      }
    }
  }

  /* ---------- Landing: barra fija que lleva a la sección de compra ---------- */
  ProductInfo.prototype.initLandingSticky = function initLandingSticky() {
    const bar = $('[data-sticky-atc]', this.root);
    if (!bar || !('IntersectionObserver' in window)) return;
    const hero = $('[data-lp-hero]');
    const section = this.root.closest('section') || this.root;
    let heroOut = !hero; let buyIn = false;
    const sync = () => {
      const show = heroOut && !buyIn;
      bar.classList.toggle('is-visible', show);
      bar.setAttribute('aria-hidden', String(!show));
      $$('button', bar).forEach((b) => { b.tabIndex = show ? 0 : -1; });
    };
    if (hero) new IntersectionObserver(([e]) => { heroOut = !e.isIntersecting; sync(); }).observe(hero);
    new IntersectionObserver(([e]) => { buyIn = e.isIntersecting; sync(); }, { threshold: 0.15 }).observe(section);
    const go = $('[data-sticky-goto]', bar);
    if (go) go.addEventListener('click', () => {
      section.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });
      const first = $('.size-grid input:not(:disabled)', this.root) || $('input[data-option-index]', this.root);
      if (first) setTimeout(() => first.focus({ preventScroll: true }), reduceMotion ? 0 : 600);
    });
  };

  /* ---------- Aparición al hacer scroll ---------- */
  const initReveal = (root = document) => {
    const els = $$('[data-reveal]:not(.is-in)', root);
    if (!els.length) return;
    if (reduceMotion || !('IntersectionObserver' in window)) { els.forEach((el) => el.classList.add('is-in')); return; }
    document.documentElement.classList.add('reveal-ready');
    const io = new IntersectionObserver((entries) => entries.forEach((en) => {
      if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); }
    }), { rootMargin: '0px 0px -10% 0px' });
    els.forEach((el) => io.observe(el));
  };

  /* ---------- Promo con código de descuento (ficha de producto) ---------- */
  const promoApplied = {};
  const applyDiscount = (code) => {
    if (!code) return Promise.resolve();
    if (promoApplied[code]) return promoApplied[code];
    const root = (T.routes && T.routes.root_url ? T.routes.root_url : '/').replace(/\/?$/, '/');
    // 1) Código en el carrito (Cart AJAX API) · 2) Cookie de descuento de Shopify como respaldo para el checkout
    promoApplied[code] = Promise.allSettled([
      fetch(`${T.routes && T.routes.cart_update_url ? T.routes.cart_update_url : root + 'cart/update'}.js`, {
        method: 'POST', credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ discount: code })
      }),
      fetch(`${root}discount/${encodeURIComponent(code)}`, { credentials: 'same-origin', redirect: 'follow' })
    ]);
    return promoApplied[code];
  };
  const initPromo = (scope = document) => {
    $$('[data-promo]:not([data-promo-ready])', scope).forEach((box) => {
      box.setAttribute('data-promo-ready', '');
      const code = box.dataset.code;
      const pct = Number(box.dataset.pct) || 0;
      applyDiscount(code);
      const priceEl = $('[data-promo-price]', box);
      const wasEl = $('[data-promo-was]', box);
      const btn = $('[data-promo-add]', box);
      document.addEventListener('variant:change', (e) => {
        const v = e.detail && e.detail.variant;
        if (!v) return;
        if (priceEl) priceEl.textContent = formatMoney(Math.round(v.price * (100 - pct) / 100));
        if (wasEl) wasEl.lastChild.textContent = formatMoney(v.price);
        if (btn) btn.disabled = !v.available;
      });
      if (btn) btn.addEventListener('click', async () => {
        const productRoot = box.closest('[data-product]') || document;
        const form = $('form[data-type="add-to-cart-form"]', productRoot);
        if (!form) return;
        btn.classList.add('is-loading'); btn.disabled = true;
        await applyDiscount(code);
        btn.classList.remove('is-loading'); btn.disabled = false;
        if (form.requestSubmit) form.requestSubmit(); else form.submit();
      });
    });
  };

  /* ---------- Tarjetas: muestras de color ---------- */
  document.addEventListener('mouseover', (e) => swatchPreview(e));
  document.addEventListener('focusin', (e) => swatchPreview(e));
  function swatchPreview(e) {
    const sw = e.target.closest && e.target.closest('.card__swatch');
    if (!sw) return;
    const card = sw.closest('.card');
    const img = $('.card__img--1', card);
    if (img && sw.dataset.img) {
      img.srcset = '';
      img.src = sw.dataset.img;
    }
    $$('.card__swatch', card).forEach((s) => s.classList.toggle('is-active', s === sw));
    if (sw.dataset.url) $$('a.card__title, a.card__media', card).forEach((a) => { a.href = sw.dataset.url; });
  }

  /* ---------- Carruseles ---------- */
  document.addEventListener('click', (e) => {
    const nav = e.target.closest('[data-slider-nav]');
    if (!nav) return;
    const slider = document.getElementById(nav.dataset.sliderNav);
    if (!slider) return;
    const dir = nav.classList.contains('prev') ? -1 : 1;
    slider.scrollBy({ left: dir * slider.clientWidth * 0.8, behavior: reduceMotion ? 'auto' : 'smooth' });
  });
  // Flechas: se desactivan al llegar a cada extremo y se ocultan si todo cabe en pantalla.
  const syncSliderNav = (slider) => {
    const navs = $$(`[data-slider-nav="${slider.id}"]`);
    if (!navs.length) return;
    const max = slider.scrollWidth - slider.clientWidth;
    const wrap = navs[0].closest('.slider-nav');
    if (wrap) wrap.hidden = max <= 4;
    navs.forEach((b) => {
      b.disabled = b.classList.contains('prev') ? slider.scrollLeft <= 4 : slider.scrollLeft >= max - 4;
    });
  };
  const initSliders = (root = document) => {
    $$('.slider[id]', root).forEach((slider) => {
      if (slider.dataset.navReady) { syncSliderNav(slider); return; }
      slider.dataset.navReady = '1';
      slider.addEventListener('scroll', debounce(() => syncSliderNav(slider), 60), { passive: true });
      syncSliderNav(slider);
    });
  };
  window.addEventListener('resize', debounce(() => initSliders(), 150));

  /* ---------- Filtros de colección (AJAX) ---------- */
  const initFacets = () => {
    const results = $('[data-collection-results]');
    if (!results) return;
    const sectionId = results.dataset.sectionId;
    const render = async (url, push = true) => {
      results.classList.add('is-loading');
      const u = new URL(url, window.location.origin);
      u.searchParams.set('section_id', sectionId);
      try {
        const html = await (await fetch(u.toString())).text();
        const doc = parseHTML(html);
        const openKeys = $$('details[data-facet-key][open]').map((d) => d.dataset.facetKey);
        const focusedName = document.activeElement && document.activeElement.name;
        const focusedValue = document.activeElement && document.activeElement.value;
        ['[data-collection-results]', '[data-facets-desktop]', '[data-facets-drawer]', '[data-collection-count]'].forEach((sel) => {
          const fresh = $(sel, doc);
          $$(sel).forEach((cur) => { if (fresh) cur.innerHTML = fresh.innerHTML; });
        });
        // Mantener abiertos los desplegables y el foco tras actualizar.
        openKeys.forEach((k) => $$(`details[data-facet-key="${k}"]`).forEach((d) => { d.open = true; }));
        if (focusedName) {
          const again = $$('[data-facets-desktop] input, [data-facets-drawer] input').find((i) => i.name === focusedName && i.value === focusedValue);
          if (again) again.focus({ preventScroll: true });
        }
        if (typeof initVideos === 'function') initVideos(results);
        u.searchParams.delete('section_id');
        if (push) window.history.pushState({ facets: true }, '', u.toString());
      } catch (err) {
        window.location.href = url;
      } finally {
        $('[data-collection-results]').classList.remove('is-loading');
      }
    };
    const fromForm = (form) => {
      const params = new URLSearchParams(new FormData(form));
      for (const [k, v] of Array.from(params.entries())) if (v === '') params.delete(k);
      const sort = $('[data-sort]');
      if (sort && !params.has('sort_by')) params.set('sort_by', sort.value);
      return `${window.location.pathname}?${params.toString()}`;
    };
    const onChange = debounce((form) => render(fromForm(form)), 350);
    document.addEventListener('change', (e) => {
      const form = e.target.closest('form[data-facets-form]');
      if (form) { onChange(form); return; }
      if (e.target.matches('[data-sort]')) {
        const f = $('form[data-facets-form]');
        if (f) { render(fromForm(f)); return; }
        const u = new URL(window.location.href);
        u.searchParams.set('sort_by', e.target.value);
        render(u.toString());
      }
    });
    document.addEventListener('input', (e) => {
      const form = e.target.closest('form[data-facets-form]');
      if (form && e.target.type === 'number') onChange(form);
    });
    document.addEventListener('submit', (e) => {
      const form = e.target.closest('form[data-facets-form]');
      if (!form) return;
      e.preventDefault();
      render(fromForm(form));
    });
    document.addEventListener('click', (e) => {
      const link = e.target.closest('[data-facet-link]');
      if (!link) return;
      e.preventDefault();
      render(link.href);
    });
    window.addEventListener('popstate', (e) => {
      if (e.state && e.state.facets) render(window.location.href, false);
    });
    // Barra horizontal: un desplegable abierto a la vez, se cierra al pulsar fuera o con Escape.
    document.addEventListener('toggle', (e) => {
      const d = e.target;
      if (!(d instanceof HTMLDetailsElement) || !d.classList.contains('facetpop') || !d.open) return;
      $$('details.facetpop[open]').forEach((o) => { if (o !== d) o.open = false; });
      const body = $('.facets__body', d);
      if (body) {
        body.style.left = '0'; body.style.right = 'auto';
        const r = body.getBoundingClientRect();
        if (r.right > window.innerWidth - 12) { body.style.left = 'auto'; body.style.right = '0'; }
      }
    }, true);
    document.addEventListener('click', (e) => {
      if (e.target.closest('details.facetpop')) return;
      $$('details.facetpop[open]').forEach((o) => { o.open = false; });
    });
    document.addEventListener('keydown', (e) => {
      if (e.key !== 'Escape') return;
      const open = $('details.facetpop[open]');
      if (open) { open.open = false; const s = $('summary', open); if (s) s.focus(); }
    });
  };

  /* ---------- Vídeos de fondo: carga al verse ---------- */
  const initVideos = (root = document) => {
    $$('video[data-autoplay]:not([data-ready])', root).forEach((video) => {
      video.setAttribute('data-ready', '');
      if (reduceMotion) return;
      const start = () => {
        $$('source[data-src]', video).forEach((s) => { s.src = s.dataset.src; s.removeAttribute('data-src'); });
        video.load();
        const p = video.play();
        if (p && p.catch) p.catch(() => {});
      };
      video.addEventListener('playing', () => video.classList.add('is-playing'), { once: true });
      if ('IntersectionObserver' in window) {
        const io = new IntersectionObserver((entries) => {
          entries.forEach((en) => {
            if (en.isIntersecting) {
              io.disconnect();
              start();
            }
          });
        }, { rootMargin: '200px' });
        io.observe(video);
      } else start();
    });
  };

  /* ---------- Plazo de entrega (hora de Madrid) ---------- */
  const madridNow = () => {
    const parts = new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/Madrid', year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', hour12: false }).formatToParts(new Date());
    const g = (t) => Number(parts.find((p) => p.type === t).value);
    return { y: g('year'), m: g('month'), d: g('day'), h: g('hour') % 24 };
  };
  const isoDay = (d) => d.toISOString().slice(0, 10);
  const isWorkday = (d, hol) => d.getUTCDay() !== 0 && d.getUTCDay() !== 6 && !hol.includes(isoDay(d));
  const addWorkdays = (d, n, hol) => {
    const r = new Date(d.getTime());
    let a = 0;
    while (a < n) {
      r.setUTCDate(r.getUTCDate() + 1);
      if (isWorkday(r, hol)) a += 1;
    }
    return r;
  };
  const initDelivery = (root = document) => {
    $$('[data-delivery]:not([data-ready])', root).forEach((el) => {
      el.setAttribute('data-ready', '');
      const out = $('[data-delivery-text]', el);
      if (!out) return;
      const cutoff = Number(el.dataset.cutoff || 13);
      const min = Number(el.dataset.min || 1);
      const max = Math.max(min, Number(el.dataset.max || 2));
      const hol = (el.dataset.holidays || '').split(',').map((s) => s.trim()).filter(Boolean);
      const now = madridNow();
      let ship = new Date(Date.UTC(now.y, now.m - 1, now.d, 12));
      if (!isWorkday(ship, hol) || now.h >= cutoff) ship = addWorkdays(ship, 1, hol);
      const from = addWorkdays(ship, min, hol);
      const to = addWorkdays(ship, max, hol);
      let fmt;
      try { fmt = new Intl.DateTimeFormat(T.locale || 'es', { weekday: 'short', day: 'numeric', month: 'short', timeZone: 'UTC' }); } catch (e) { fmt = new Intl.DateTimeFormat('es', { weekday: 'short', day: 'numeric', month: 'short', timeZone: 'UTC' }); }
      const tpl = from.getTime() === to.getTime() ? el.dataset.templateOne : el.dataset.template;
      if (tpl) out.textContent = tpl.replace('[from]', fmt.format(from)).replace('[to]', fmt.format(to));
    });
  };

  /* ---------- Test de compra ---------- */
  class Quiz {
    constructor(root) {
      this.root = root;
      this.steps = $$('.quiz__step', root);
      this.results = $$('.quiz__result', root);
      this.meta = $('.quiz__meta', root);
      this.progress = $('.quiz__progress', root);
      this.counter = $('[data-quiz-current]', root);
      this.back = $('[data-quiz-back]', root);
      this.live = $('[data-quiz-live]', root);
      this.answers = [];
      this.index = 0;
      root.addEventListener('click', (e) => {
        const opt = e.target.closest('[data-answer]');
        if (opt) return this.answer(opt);
        if (e.target.closest('[data-quiz-back]')) this.go(this.index - 1, true);
        if (e.target.closest('[data-quiz-restart]')) this.restart();
      });
      this.go(0, false);
    }
    answer(opt) {
      $$('[data-answer]', opt.closest('.quiz__step')).forEach((b) => b.setAttribute('aria-pressed', String(b === opt)));
      this.answers[this.index] = opt.dataset.answer;
      this.answers.length = this.index + 1;
      if (this.index < this.steps.length - 1) this.go(this.index + 1, true);
      else this.show();
    }
    go(i, focus) {
      if (i < 0) return;
      this.index = i;
      this.results.forEach((r) => { r.hidden = true; });
      this.steps.forEach((s, n) => { s.hidden = n !== i; });
      [this.meta, this.progress].forEach((el) => { if (el) el.hidden = false; });
      if (this.progress) this.progress.style.setProperty('--progress', `${((i + 1) / this.steps.length) * 100}%`);
      if (this.counter) this.counter.textContent = String(i + 1);
      if (this.back) this.back.hidden = i === 0;
      if (focus) { const q = $('.quiz__question', this.steps[i]); if (q) q.focus({ preventScroll: true }); }
    }
    matches(r) {
      const [use, exp, grip] = this.answers;
      const g = grip === 'T' ? 'T' : 'Y';
      const ok = (rule, v) => !rule || rule === 'any' || rule.split(',').includes(v);
      return r.dataset.grip === g && ok(r.dataset.use, use) && ok(r.dataset.exp, exp);
    }
    show() {
      const r = this.results.find((x) => this.matches(x)) || this.results[this.results.length - 1];
      this.steps.forEach((s) => { s.hidden = true; });
      [this.meta, this.progress, this.back].forEach((el) => { if (el) el.hidden = true; });
      if (!r) return;
      r.hidden = false;
      const h = $('.quiz__name', r);
      if (h) h.focus({ preventScroll: false });
      if (this.live && h) this.live.textContent = h.textContent.trim();
    }
    restart() {
      this.answers = [];
      $$('[data-answer]', this.root).forEach((b) => b.setAttribute('aria-pressed', 'false'));
      this.go(0, true);
    }
  }

  /* ---------- Selector de idioma y país ---------- */
  document.addEventListener('change', (e) => {
    const sel = e.target.closest('[data-localization-select]');
    if (sel) sel.form.submit();
  });

  /* ---------- Inicio ---------- */
  const init = (root = document) => {
    $$('[data-product]', root).forEach((el) => { if (!el._pi) el._pi = new ProductInfo(el); });
    $$('[data-quiz]', root).forEach((el) => { if (!el._q) el._q = new Quiz(el); });
    initVideos(root);
    initDelivery(root);
  };
  const boot = () => {
    initAnnouncement();
    initHeader();
    initNav();
    initSearch();
    initFacets();
    initReveal();
    initSliders();
    initPromo();
    init(document);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', (e) => { init(e.target); initAnnouncement(); initReveal(e.target); initSliders(e.target); initPromo(e.target); });
  document.addEventListener('cart:updated', () => initDelivery(document));

  window.RratsTheme = { formatMoney, addToCart, openCart, toast };
})();
